module.exports = __webpack_public_path__ + "2d8da3cf947c41b1508ff167e263f388.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/beach-bungalow-main.png
// module id = 547
// module chunks = 0